import classNames from 'classnames'
import React from 'react'

export interface LayoutCardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean
  fullHeight?: boolean
  fullWidth?: boolean
  pxOffsetBottom?: number
  fullWidthOffset?: number
}

export const LayoutCard = ({
  noPadding,
  children,
  className,
  fullHeight,
  fullWidth,
  pxOffsetBottom = 32,
  fullWidthOffset,
  ...props
}: LayoutCardProps) => {
  return (
    <div
      {...props}
      data-layout-card
      className={classNames(
        className,
        'bg-white rounded-lg drop-shadow-02 overflow-auto',
        fullWidth && !fullWidthOffset && 'w-screen',
        fullHeight ? 'flex-1 h-full min-h-0 flex flex-col' : 'h-auto',
        noPadding ? 'p-0' : 'p-8 pt-6'
      )}
      style={{
        ...props.style,
        width: fullWidth && fullWidthOffset ? `calc(100vw - ${fullWidthOffset}px)` : undefined
      }}
    >
      {children}
    </div>
  )
}
